import Image1 from './images/image1.jpg';
import Image2 from './images/image2.jpg';
import Image3 from './images/image3.jpg';
import Image4 from './images/image4.jpg';
import Image5 from './images/image5.jpg';
import Image6 from './images/image6.jpg';
import Image7 from './images/image7.jpg';

export const content = [
  {
    name: 'Артем Щукин',
    rating: '5,0',
    reviews: '137 отзывов',
    img: Image1,
  },
  {
    name: 'Дарья Давыдова',
    rating: '5,0',
    reviews: '79 отзывов',
    img: Image2,
  },
  {
    name: 'Дмитрий Гаврилов',
    rating: '5,0',
    reviews: '85 отзывов',
    img: Image3,
  },
  {
    name: 'Мария Власова',
    rating: '4,8',
    reviews: '67 отзывов',
    img: Image4,
  },
  {
    name: 'Юлия Белоусова',
    rating: '4,9',
    reviews: '78 отзывов',
    img: Image5,
  },
  {
    name: 'Максим Грачев',
    rating: '4,9',
    reviews: '49 отзывов',
    img: Image6,
  },
  {
    name: 'Михаил Котов',
    rating: '4,8',
    reviews: '56 отзывов',
    img: Image7,
  },
];
